import { useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import TranslateTemplateSection from './TranslateTemplateSection';
import TranslateTemplateTextFieldGroup from './TranslateTemplateTextFieldGroup';
import TranslateTemplateUISelectGroup from './TranslateTemplateUISelectGroup';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function TranslateTemplateSupportFormSection(props) {
  const {
    languages,
    onBackClick,
    onFieldChange,
    values
  } = props;
  const supportFormTitles = useMemo(() => values.map(langValues => langValues.supportFormTitle), [values]);
  const supportFormIds = useMemo(() => values.map(langValues => langValues.supportFormId), [values]);
  return /*#__PURE__*/_jsxs(TranslateTemplateSection, {
    onBackClick: onBackClick,
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "knowledgeContentUI.templateEditor.translateModal.sections.supportForm.header"
    }),
    children: [/*#__PURE__*/_jsx(TranslateTemplateUISelectGroup, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "knowledgeContentUI.templateEditor.translateModal.sections.supportForm.fieldLabels.supportSelectFormText"
      }),
      onChange: (language, value) => onFieldChange(language, 'supportFormId', value),
      values: supportFormIds,
      languages: languages
    }), /*#__PURE__*/_jsx(TranslateTemplateTextFieldGroup, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "knowledgeContentUI.templateEditor.translateModal.sections.supportForm.fieldLabels.supportFormLinkText"
      }),
      onChange: (language, value) => onFieldChange(language, 'supportFormTitle', value),
      values: supportFormTitles,
      languages: languages
    })]
  });
}